import { logger } from '@sheerid/jslib';

export const redirect = (redirectDestination: string) => {
    const win = window.open(redirectDestination, '_parent') as Window;
    win.focus();
};

export const getQueryParamsByName = (queryParamName: string) => {
    const urlParams = new URLSearchParams(window.location.search);
    const queryParam = urlParams.get(queryParamName);

    if (queryParam) {
        return queryParam;
    }
    return null;
};

export const getQueryParamsFromUrl = (url?: string) => {
    const newUrl = new URL(url || window.location.toString());
    return new URLSearchParams(newUrl.search.slice(1));
};

export const sendPostMessage = (message: any, url?: string) => {
    try {
        window.parent.postMessage(message, url || '*');
        logger.info(`postMessage sent to ${url || '*'} with message:`, message);
    } catch (e) {
        logger.error('postMessage failed to send', e.toString());
    }
};
